import { useState, useEffect } from "react";
import I18n from "common/i18n";
import { useScale } from "common/utils";
import { Layout, Overlay } from "features/creator/tutorial/top/stages/Layout";
import { Title } from "../Title";

const Step = (props: { back: () => void; next: () => void; close: () => void }) => {
  const { scale } = useScale();
  const { back, next, close } = props;
  const [panelRect, setPanelRect] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });

  useEffect(() => {
    setTimeout(() => {
      const panel = document.getElementById("user-project-panel-drawer");
      const rect = panel.getBoundingClientRect();
      setPanelRect({
        x: rect.x - 50 * scale,
        y: rect.y - 70 * scale,
        width: 450 * scale,
        height: 450 * scale,
      });
    }, 300);
  }, [scale]);

  return (
    <>
      <Overlay area={panelRect}>
        <></>
      </Overlay>

      <Layout transparent back={back} next={next} close={close}>
        <Title activeStep={5} />

        <div className="flex-col-el items-start justify-center w-[312px] gap-1">
          <div className="flex-row-el flex-center px-3 bg-orange-100 rounded-xl">
            <p className="text-body text-[20px] leading-9 text-white">
              {I18n.t("MSG_CREATOR_APP_MY_APPS")}
            </p>
          </div>

          <p className="text-body text-textcolor-black text-[22px] whitespace-pre">
            {I18n.locale === "ja"
              ? "アプリを つくったら\nここに ひょうじ\nされます。"
              : "アプリを作ったら\nここに表示\nされます。"}
          </p>
        </div>
      </Layout>
    </>
  );
};

export default Step;
